
import React, { useState, useEffect, useRef } from 'react'
import Axios from 'axios';
import { API_BASE_URL, PRINT_INVOICE, GET_PO_RECEIVED_BY_ID, GET_INVOICE_PAYMENTS } from '../../../Config';
import PrintContent from './print';
import PropTypes from 'prop-types';


const ViewInvocie = ({ INVObj }) => {
    
    const [userDataSession, setUserDataSession] = useState([]);
    const [formattedDate, setFormattedDate] = useState('');
    const [loading, setLoading] = useState('');
    const [firstData, setFirstData] = useState(null);
    const [totalAmount, setTotalAmount] = useState("");
    const [taxAmount, setTaxAmount] = useState("");
    const [viewProducts, setViewProducts] = useState([]);
    const [invoiceData, setInvoiceData] = useState(null);
    const [viewPayments, setViewPayments] = useState([]);

    const printRef = useRef();

    const handlePrint = () => {
        if (printRef.current) {
            console.log('printRef.current:', printRef.current);
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Print</title>
                    </head>
                    <body>
                        <div>${printRef.current.innerHTML}</div>
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          } else {
            console.error('printRef.current is undefined');
          }
    };

    // #region Session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        // Parse and format PODate
        console.log(INVObj, 'invoice obj')
        if (INVObj && INVObj.InvoiceDate) {
            const poDate = new Date(INVObj.InvoiceDate);
            const formatted = poDate.toISOString().split('T')[0];
            setFormattedDate(formatted);
        }
    }, [INVObj]);

    useEffect(() => {
        console.log(INVObj.PurchaseId)
        if (userDataSession && userDataSession.OrgId && INVObj && INVObj.PurchaseId){
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_PO_RECEIVED_BY_ID}?PurchaseId=${INVObj.PurchaseId}&UserId=${userDataSession.UserId}`)
                .then(response => {
                    if (response.data.Status) {
                        setLoading(false);
                        setViewProducts(response.data.ResultData);
                        setFirstData(response.data.ResultData[0]);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                });
            Axios.get(`${API_BASE_URL}${GET_INVOICE_PAYMENTS}?PurchaseId=${INVObj.PurchaseId}`)
                .then(response => {
                    if (response.data.Status) {
                        setViewPayments(response.data.ResultData);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    
    }, [userDataSession, INVObj]);

    useEffect(() => {
        const fetchInvoiceData = async () => {
            console.log(INVObj.PurchaseId, 'invobj invobj invobjinvobjinvobj')
          try {
            const response = await Axios.get(
              `${API_BASE_URL}${PRINT_INVOICE}?Id=${INVObj?.PurchaseId}`
            );
            console.log(response.data, 'a a a a a aa a a a ')
            if (response.data) {
              setInvoiceData(response.data.ResultData[0]);
              console.log(response.data.ResultData, 'response.data.ResultData')
            }
          } catch (error) {
            console.error("Error fetching invoice data:", error);
          }
        };
    
        fetchInvoiceData();
    }, [INVObj.PurchaseId]);

    // useEffect(() => {
    //     if (userDataSession && userDataSession.OrgId && INVObj && INVObj.PurchaseId){
    //         setLoading(true);
    //         const url = `${API_BASE_URL}${GET_PO_BY_ID}?UserId=${userDataSession.UserId}&PurchaseId=${INVObj.PurchaseId}`;
    //         Axios.get(url)
    //             .then(response => {
    //                 if (response.data.Status) {
    //                     setViewProducts(response.data.ResultData);
    //                     setFirstData(response.data.ResultData[0]);
    //                     setLoading(false);
    //                 } else {
    //                     console.error('Error fetching data:', response.data.Message);
    //                     setLoading(false);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching data:', error);
    //                 setLoading(false);
    //             });
    //     }
    
    // }, [userDataSession, INVObj]);

    useEffect(() => {
        let totalTaxAmt = 0;
        let totalAmount = 0;
    
        if (viewProducts && viewProducts.length > 0) {
    
            totalTaxAmt = viewProducts.reduce((acc, product) => {
                const taxRate = product.CGSTRate + product.SGSTRate;
                const taxAmount = (product.UnitPrice * product.Quantity * taxRate) / 100;
                return acc + (taxAmount || 0);
            }, 0);
    
            totalAmount = viewProducts.reduce((acc, product) => {
                const amount = product.UnitPrice * product.Quantity;
                return acc + (amount || 0);
            }, 0);
        }
    
        setTaxAmount(totalTaxAmt);
        setTotalAmount((totalAmount + totalTaxAmt) - (INVObj?.DiscountAmount)); 
    }, [viewProducts]);  

     
    return (
        <div>
            {/* Add Purchase */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightInvView"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "300px", maxWidth: "53%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">View Invoice (INV-{firstData ? firstData.AutoGenTransactionNo : ''})</h4>
                    <span className={`ms-3 badge fw-bold ${
                        INVObj
                            ? INVObj.InvoiceStatus == 'PAID'
                            ? 'bg-outline-success'
                            : INVObj.InvoiceStatus == 'PENDING'
                            ? 'bg-outline-warning'
                            : INVObj.InvoiceStatus == 'PARTIALLYPAID'
                            ? 'bg-outline-info'
                            : ''
                            : ''
                        } mt-2`}> 
                        {INVObj ? INVObj.InvoiceStatus : ''}
                    </span>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    
                {/* </div> */}
                <div className='col-lg-1 col-md-1 col-sm-4 ms-auto'>
                    <button className='btn border' type='button' title="Print Invocie" onClick={handlePrint}>
                        <i className="fa-solid fa-print fs-4 text-primary"></i>
                    </button>
                </div>
                <form>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="input-blocks add-product">
                                <label>Supplier Name</label>
                                <div className="row">
                                    <div className="col-lg-10 col-sm-10 col-10">
                                        <input
                                            type='text'
                                            className='form-control'
                                            value={firstData ? firstData.SupplierName : ''}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="input-blocks">
                                <label>Date</label>
                                <div className="input-groupicon calender-input">
                                    <input 
                                        type='date'
                                        className='form-control'
                                        value={formattedDate}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 form-group'>
                            <label className='form-label'>Discount Type</label>
                            <input
                                type='text' // Change to text to display the string "After Tax" or "Before Tax"
                                className='form-control'
                                value={
                                firstData
                                    ? firstData.DiscountType == 2
                                    ? 'Perecentage'
                                    : firstData.DiscountType == 1
                                    ? 'Fixed'
                                    : ''
                                    : ''
                                }
                                readOnly
                            />
                        </div>
                        <div className=' col-lg-3 col-md-3form-group'>
                            <label className='form-label'>Discount</label>
                            <input
                                type='float'
                                className='form-control'
                                value={firstData ? firstData.DiscountAmount : ''}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="row mb-2 mt-2">
                        <div className="col-lg-12">
                            <div className="modal-body-table">
                                <div className="table-responsive">
                                    <table className="table  datanew">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                <th>Unit Price</th>
                                                <th>Units</th>
                                                <th>Tax</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="12" className="text-center">Loading...</td>
                                                </tr>
                                            ) : (
                                                viewProducts.length !== 0 ? (
                                                    viewProducts.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.Productname}</td>
                                                            <td>{item.Quantity}</td>
                                                            <td>{item.UnitPrice}</td>
                                                            <td>{item.Units}</td>
                                                            <td>{item.CGSTRate}, {item.SGSTRate}</td>
                                                            <td>
                                                                {(
                                                                    ((item.Quantity || 0) * (item.UnitPrice || 0)) + 
                                                                    (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100 * (item.Quantity || 0) * (item.UnitPrice || 0))
                                                                ).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">No Data available</td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>     
                                    {/* <div className=' mt-2'>
                                        <p className='badge badge-primary fs-6 col-3'>Total Discount: <span className='fw-bold fs-5'>{Number(INVObj?.DiscountAmount || 0).toFixed(2)}</span></p>
                                        <p className='badge badge-primary fs-6 col-3'>Total Tax: <span className='fw-bold fs-5'>{Number(taxAmount || 0).toFixed(2)}</span></p>
                                        <p style={{ height: '1.8rem' }} className='badge badge-primary fs-6 col-4'>Total Amount: <span className='fw-bold fs-5'>{Number(totalAmount|| 0).toFixed(2)}</span></p>
                                    </div> */}
                                     <div className='d-flex justify-content-between mt-2'>
                                        <h5>Total Discount: <span className='fw-bold fs-5 text-primary'>{Number(INVObj?.DiscountAmount || 0).toFixed(2)}</span></h5>
                                        <h5>Total Tax: <span className='fw-bold text-primary fs-5'>{Number(taxAmount || 0).toFixed(2)}</span></h5>
                                        <h5>Total Amount: <span className='fw-bold text-primary fs-5'>{Number(totalAmount|| 0).toFixed(2)}</span></h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="input-blocks">
                                    <label>Shipment Details</label>
                                    <textarea 
                                        readOnly
                                    >
                                        {INVObj?.Notes}
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            </div>
                       
            {/* /View Invoice */}

            <div className='d-none'>
                {invoiceData ? (
                    <PrintContent ref={printRef} data={invoiceData} invObj={INVObj} viewProducts={viewProducts} viewPayments={viewPayments} />
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </div>
    )
}

ViewInvocie.propTypes = {
    INVObj: PropTypes.object.isRequired,
};

export default ViewInvocie
